import $ from 'jquery';
import mobileHeader from '../header/mobile-header';
import '../../vendor/jquery.outside-events';

$('.js-toolbox').append('<span class="js-lightbox" data-target="lang-switch" />');

var container = $('.lang-switch');
var trigger = $('.toggle-mobile', container);
var lightbox = $('.js-lightbox[data-target="lang-switch"]');
var activeClass = 'js-active';

trigger.on('click', function (e) {
  container.toggleClass(activeClass);
  lightbox.toggleClass(activeClass);
  mobileHeader.resetAll();
});

container.on('clickoutside', resetAll);

function resetAll() {
  container.removeClass(activeClass);
  lightbox.removeClass(activeClass);
}
